"use strict";

var _WeakMap = require("@babel/runtime-corejs3/core-js-stable/weak-map");
var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/extends"));
var _bind = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/bind"));
var _isArray = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/array/is-array"));
var _map = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/map"));
var _filter = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/filter"));
var _setTimeout2 = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/set-timeout"));
var _react = _interopRequireDefault(require("react"));
var T = _interopRequireWildcard(require("prop-types"));
var _classnames = _interopRequireDefault(require("classnames"));
var _AuComponent = _interopRequireDefault(require("../AuComponent"));
var _AutoIntl = _interopRequireDefault(require("../AutoIntl"));
var _Filter = require("./Filter");
var _constants = require("../../../constants");
var _AuAnalytics = _interopRequireDefault(require("../../../utils/AuAnalytics"));
var _context, _context2, _context3, _context4, _context5;
function _getRequireWildcardCache(e) { if ("function" != typeof _WeakMap) return null; var r = new _WeakMap(), t = new _WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = _Object$defineProperty && _Object$getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? _Object$getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? _Object$defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
var styles = {
  "container": "filter_segment-module__container___SWmaO",
  "show": "filter_segment-module__show___mF0i5",
  "open": "filter_segment-module__open____iEG5",
  "filter": "filter_segment-module__filter___PfBXW",
  "header": "filter_segment-module__header___ntpH3",
  "toggle": "filter_segment-module__toggle___EHJ2E",
  "icon": "filter_segment-module__icon___hwoRn",
  "visible": "filter_segment-module__visible___fbQJD",
  "filter_header": "filter_segment-module__filter_header___JDqio",
  "unknown": "filter_segment-module__unknown___F3Em0",
  "selection": "filter_segment-module__selection___uybT0",
  "counter": "filter_segment-module__counter___bCtpJ",
  "close": "filter_segment-module__close___d49tA",
  "loader": "filter_segment-module__loader___qCSN6",
  "pill": "filter_segment-module__pill___rg4B7",
  "title": "filter_segment-module__title___Uqakc",
  "padding": "filter_segment-module__padding___kMue_",
  "button": "filter_segment-module__button___dNT5M",
  "selection_container": "filter_segment-module__selection_container___onMXy",
  "dd_wrapper": "filter_segment-module__dd_wrapper___h8553",
  "dropdown": "filter_segment-module__dropdown___x9RUg"
};
class FilterSegment extends _AuComponent.default {
  static propTypes = {
    Filter: T.oneOfType([T.func, T.object]).isRequired,
    name: T.string.isRequired,
    displayId: T.string,
    selection: T.arrayOf(_Filter.Filter),
    customProperties: T.object,
    contentRef: T.object,
    className: T.string,
    visibleClassName: T.string,
    expandedClassName: T.string,
    iconClassName: T.string,
    headerClassName: T.string,
    filterClassName: T.string,
    multiSelect: T.bool,
    hideClearBtn: T.bool,
    onFilterInit: T.func,
    onFilterChange: T.func,
    showRemoveBtn: T.bool
  };
  static defaultProps = {
    multiSelect: false,
    hideClearBtn: false,
    showRemoveBtn: true,
    selection: [],
    contentRef: {},
    onFilterInit: _constants.NOOP,
    onFilterChange: _constants.NOOP
  };
  state = {
    initialized: false,
    isOpen: false
  };
  containerRef = /*#__PURE__*/_react.default.createRef();
  toggleOpen = (0, _bind.default)(_context = this.toggleOpen).call(_context, this);
  toggleOpen() {
    this.setState(prevState => {
      this.trackFilterEvent({
        action: prevState.isOpen ? 'CollapseFilter' : 'ExpandFilter'
      });
      return {
        isOpen: !prevState.isOpen
      };
    });
  }
  trackFilterEvent({
    category = 'SidebarFilters',
    action,
    label
  }) {
    const {
      displayId,
      displayString
    } = this.props;
    // const filter = displayId ? formatMessage({id: displayId}) : displayString || 'UnknownFilter';
    const filter = 'UnknownFilter'; //TODO Fix the format message
    _AuAnalytics.default.trackEvent({
      category,
      action: action + ': ' + filter,
      label
    });
  }
  trackFilterChange(selectedItems, action = 'ChangeFilter') {
    const label = (0, _isArray.default)(selectedItems) ? (0, _map.default)(selectedItems).call(selectedItems, i => i.urlValue).join(', ') : selectedItems.urlValue;
    this.trackFilterEvent({
      action,
      label
    });
  }
  clearSelection = (0, _bind.default)(_context2 = this.clearSelection).call(_context2, this);
  clearSelection() {
    this.trackFilterEvent({
      action: 'ClearFilter',
      label: '*empty*'
    });
    this.commitChanges([]);
  }
  removeSelection = (0, _bind.default)(_context3 = this.removeSelection).call(_context3, this);
  removeSelection(item) {
    const {
      selection
    } = this.props;
    this.trackFilterEvent({
      action: 'RemoveFilter',
      label: item.urlValue
    });
    const newSelection = (0, _filter.default)(selection).call(selection, prevItem => prevItem !== item);
    this.commitChanges(newSelection);
  }
  initializeFilter(selectedItems) {
    const {
      name: filterName,
      onFilterInit
    } = this.props;
    if (selectedItems.length) {
      this.trackFilterChange(selectedItems, 'InitFilter');
    }
    onFilterInit(filterName, selectedItems);
  }
  handleOnInit = (0, _bind.default)(_context4 = this.handleOnInit).call(_context4, this);
  handleOnInit(selectedItems) {
    this.initializeFilter(selectedItems);
    this.setState({
      initialized: true
    });
  }
  handleOnChange = (0, _bind.default)(_context5 = this.handleOnChange).call(_context5, this);
  handleOnChange(selectedItems) {
    this.setState((prevState, props) => {
      this.trackFilterChange(selectedItems);
      if (props.selection.length < selectedItems.length) {
        (0, _setTimeout2.default)(() => {
          // so the scrollTop is set to the scrollHeight after the new filter is added
          if (this.containerRef.current) {
            this.containerRef.current.scrollTop = this.containerRef.current.scrollHeight;
          }
        });
      }
      return {
        isOpen: this.props.multiSelect ? prevState.isOpen : false,
        initialized: true
      };
    }, () => this.commitChanges(selectedItems));
  }
  commitChanges(selectedItems) {
    const {
      name: filterName,
      onFilterChange
    } = this.props;
    onFilterChange(filterName, selectedItems);
  }
  renderSelection() {
    const {
      selection,
      showRemoveBtn
    } = this.props;
    const selectedFilters = (0, _map.default)(selection).call(selection, item => {
      if (item.shouldDisplayBubble) {
        return /*#__PURE__*/_react.default.createElement("div", {
          className: styles.selection,
          key: item.urlKey + ":" + item.urlValue
        }, /*#__PURE__*/_react.default.createElement("div", {
          className: styles.pill
        }, /*#__PURE__*/_react.default.createElement(_AutoIntl.default, {
          displayId: item.bubbleDisplayId,
          displayString: item.bubbleText,
          className: styles.title
        }), showRemoveBtn && /*#__PURE__*/_react.default.createElement("a", {
          className: styles.close,
          onClick: () => {
            this.removeSelection(item);
          }
        })));
      }
      return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, {
        key: item.urlKey + ":" + item.urlValue
      });
    });
    return /*#__PURE__*/_react.default.createElement("div", {
      className: styles.selection_container,
      ref: this.containerRef
    }, selectedFilters);
  }
  render() {
    const {
      selection,
      className,
      visibleClassName,
      expandedClassName,
      iconClassName,
      headerClassName,
      filterClassName,
      Filter,
      contentRef,
      displayId,
      displayString,
      hideClearBtn,
      ...otherProps
    } = this.props;
    const {
      initialized,
      isOpen
    } = this.state;
    const classes = (0, _classnames.default)(styles.container, className, {
      [styles.show]: initialized,
      [styles.open]: isOpen,
      [expandedClassName]: isOpen,
      [visibleClassName]: initialized
    });
    return /*#__PURE__*/_react.default.createElement("div", {
      className: classes
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: (0, _classnames.default)({
        [styles.padding]: selection.length >= 1
      }, headerClassName)
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: styles.toggle,
      onClick: this.toggleOpen
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: (0, _classnames.default)(styles.icon, iconClassName || styles.unknown)
    }), /*#__PURE__*/_react.default.createElement(_AutoIntl.default, {
      displayId: displayId,
      displayString: displayString
    }), selection.length > 0 && hideClearBtn === false && /*#__PURE__*/_react.default.createElement(_AutoIntl.default, {
      displayId: 'au.filterSegment.clear',
      tag: "a",
      onClick: this.clearSelection,
      className: styles.button
    })), this.renderSelection()), /*#__PURE__*/_react.default.createElement("div", {
      className: (0, _classnames.default)((0, _filter.default)(styles), filterClassName)
    }, Filter && /*#__PURE__*/_react.default.createElement(Filter, (0, _extends2.default)({}, otherProps, {
      selection: selection,
      onChange: this.handleOnChange,
      onInit: this.handleOnInit,
      containerRef: contentRef.current
    }))));
  }
}
exports.default = FilterSegment;